import type { RequestConfig } from "@app/config/axios/http";
import { stockOptionsApi } from "./api.core";
import type { ApiStockOptionsData } from "./types";

/** Сервисный слой — общие параметры СУ/УП. */
export const stockOptionsServices = {
    /**
     * Загружает общие параметры СУ.
     * @param config опции HTTP-запроса
     */
    load: async (config?: RequestConfig): Promise<ApiStockOptionsData> => {
        return stockOptionsApi.load(config);
    },
} as const;
